// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { Table } from '@shared/ui-kit/components';
import { defineComponent } from '@shared/ui-kit';
import { useTransactionsTable } from './use-transactions-table';

export const TransactionsTable = defineComponent({
  displayName: 'TransactionsTable',
  useSetup: useTransactionsTable,
  View: ({ columns, data, onRowClick }) => (
    <div className="overflow-x-auto">
      <Table.Grouped
        data={data}
        columns={columns}
        className="max-h-[320px]"
        enablePagination
        pageSize={50}
        pageCount={data.length}
        onRowClick={onRowClick}
        data-testid="transactions-table"
      />
    </div>
  ),
});
